import { useCallback, useEffect, useRef, useState } from "react";

export default function useResizeObserver(delay = 250) {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
    const [isResizing, setIsResizing] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const resizeTimeout = useRef<any>(null);
    const elementRef = useRef(null);

    const handleResize = useCallback(
        (entries: ResizeObserverEntry[]) => {
            const entry = entries[0];
            if (resizeTimeout.current) {
                clearTimeout(resizeTimeout.current);
            }
            setIsResizing(true);
            setDimensions({
                width: entry.contentRect.width,
                height: entry.contentRect.height,
            });
            resizeTimeout.current = setTimeout(() => {
                setIsResizing(false);
            }, delay);
        },
        [delay],
    );

    useEffect(() => {
        const element = elementRef.current;
        if (!element) return;

        const resizeObserver = new ResizeObserver(handleResize);
        resizeObserver.observe(element);

        return () => {
            if (resizeTimeout.current) {
                clearTimeout(resizeTimeout.current);
            }
            resizeObserver.disconnect();
        };
    }, [handleResize]);

    return { elementRef, dimensions, isResizing };
}
